<template>
  <div id="app" ref="app">
    <div
      v-if="isLoading"
      class="loadingBar"
    ></div>
    <b-notification
      v-if="isIE"
      class="fob-hide-in-print"
      style="margin: 0.5rem;"
      type="is-danger"
      has-icon :closable="false"
    >
      <translate>browser.outdated</translate>
    </b-notification>
	<!--
    <fob-header
      v-if="$leurisMode === 'FOB' && authorized"
      id="fob-header">
    </fob-header>
	-->
    <div id="fob-main-section" class="section" style="padding-top: 20px">
      <div class="columns">
        <div class="column is-narrow">
          <fob-menu id="fob-menu"></fob-menu>
        </div>

        <div class="column">
          <router-view></router-view>
        </div>

      </div>
      <!--
      <fob-footer></fob-footer>
      -->
    </div>
  </div>
</template>

<script>

import { DetectMSBrowser } from '@/utils'
import { mapGetters } from 'vuex'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import FobFooter from '@/components/Footer'
import FobHeader from '@/components/Header'
import Menu from '@/components/Menu'

export default {
  name: 'fob2017',
  mixins: [DateTimeHelper],
  computed: {
    ...mapGetters({
      confirmPrivacyPolicy: 'confirmPrivacyPolicy',
      authorized: 'user/isAuthorized'
    }),
    isLoading () {
      return this.$store.getters['isLoading']
    },
    isIE () {
      let version = DetectMSBrowser()
      return version && version < 12
    }
  },
  methods: {
    showCookieSnackbar () {
      // only show snackbar if it is not confirmed
      if (!this.confirmPrivacyPolicy) {
        this.$snackbar.open({
          indefinite: true,
          message: this.$gettext('confirmPrivacyPolicy'),
          type: 'is-primary',
          position: 'is-bottom-right',
          actionText: 'OK',
          queue: false,
          onAction: () => {
            this.$store.dispatch('confirmPrivacyPolicy')
          }
        })
      }
    }
  },
  mounted () {
    // check confirmation for privacy policy on each application launch
    this.showCookieSnackbar()

    let responseData = localStorage.getItem('leuris:login-response')
    if (responseData) {
      let response = JSON.parse(responseData)
      this.$store
        .dispatch('user/setupUserSession', response)
        .then(() => {
          if (this.$leurisMode === 'FOB' && this.$route.name === 'login') {
            this.$router.push({ name: 'start' })
          }
        })
    } else {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          if (this.$leurisMode === 'FOB') {
            this.$router.push({ name: 'login' })
          }
        })
    }

    let language = localStorage.getItem('leuris:current-lang')
    if (language === 'en') {
      this.$store.dispatch('setLanguage', 'en_150')
    } else {
      this.$store.dispatch('setLanguage', 'de_DE')
    }

    window.addEventListener('leuris:user-logged-in', (_e) => {
      let responseData = localStorage.getItem('leuris:login-response')
      let response = JSON.parse(responseData)
      this.$store
        .dispatch('user/setupUserSession', response)
        .then(() => {
          if (this.$leurisMode === 'FOB' && this.$route.name === 'login') {
            this.$router.push({ name: 'start' })
          }
        })
    })

    window.addEventListener('leuris:user-logged-out', (_e) => {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          if (this.$leurisMode === 'FOB') {
            this.$router.push({ name: 'login' })
          }
        })
    })

    window.addEventListener('leuris:language-changed', (e) => {
      if (e.detail === 'de') {
        this.$store.dispatch('setLanguage', 'de_DE')
      } else {
        this.$store.dispatch('setLanguage', 'en_150')
      }
    })
  },
  watch: {
    currentLocale () {
      // if language has changed and snackbar for privacy policy is not already confirmed
      // close exisiting snackbar and relaunch with correct current locale text message
      // (due to static text message on buefy snackbars)
      let snackbarItems = document.getElementsByClassName('notices')
      while (snackbarItems.length > 0) {
        snackbarItems[0].parentNode.removeChild(snackbarItems[0])
      }
      this.showCookieSnackbar()
    }
  },
  components: {
    'fob-footer': FobFooter,
    'fob-header': FobHeader,
    'fob-menu': Menu
  }
}
</script>

<style lang="scss">
// html {
//   // https://css-tricks.com/perfect-full-page-background-image/
//   background: url(assets/bg.png) no-repeat center center fixed;
//   -webkit-background-size: cover;
//   -moz-background-size: cover;
//   -o-background-size: cover;
//   background-size: cover;
//   height: 100%;
// }


// svg example
// html {
//   background: url(assets/buehne_l_red.svg) no-repeat top right fixed;
//   background-size: contain;
//   -webkit-background-size: contain;
//   -moz-background-size: contain;
//   -o-background-size: contain;
//   background-size: contain;
// }

#app {
  font-family: 'Nunito Sans', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-bottom: 100px;
}

@font-face {
  font-family: 'Futura';
  font-style: normal;
  font-weight: 300;
  src: url(/fonts/futura-normal.woff2) format('woff2');
}

@font-face {
  font-family: 'Futura';
  font-style: oblique;
  font-weight: 300;
  src: url(/fonts/futura-oblique.woff2) format('woff2');
}

@font-face {
  font-family: 'Futura';
  font-style: italic;
  font-weight: 300;
  src: url(/fonts/futura-oblique.woff2) format('woff2');
}

@font-face {
  font-family: 'Futura';
  font-style: normal;
  font-weight: 900;
  src: url(/fonts/futura-bold.woff2) format('woff2');
}

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

$family-sans-serif: "Nunito Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
$family-primary: $family-sans-serif;

// UL official colors
$garnet: #B02F2C;
$garnet-invert: findColorInvert($garnet);
$carnelian: #D8413E;
$carnelian-invert: findColorInvert($carnelian);
$basalt: #262A31;
$basalt-invert: findColorInvert($basalt);
// $aquamarine: #8AC2D1;
$aquamarine: #507D8E;
$aquamarine-invert: findColorInvert($aquamarine);
$lightgray: #dbdbdb;
$lightgray-invert: findColorInvert($lightgray);
$switch-grey: #b5b5b5;
$switch-grey-invert: findColorInvert($switch-grey);

$primary: $aquamarine;
$primary-invert: $aquamarine-invert;

$danger: $carnelian;
$danger-invert: $carnelian-invert;

$success: $aquamarine;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "lightgray": ($lightgray, $lightgray-invert),
    "garnet": ($garnet, $garnet-invert),
    "carnelian": ($carnelian, $carnelian-invert),
    "basalt": ($basalt, $basalt-invert),
    "aquamarine": ($aquamarine, $aquamarine-invert),
    "switch-grey": ($switch-grey, $switch-grey-invert)
);

$navbar-height: 2.5rem;

$panel-heading-line-height: 1;
$panel-heading-size: 1.2em;
$panel-heading-weight: $weight-semibold;
$panel-heading-background-color: $aquamarine;
$panel-heading-color: $white;

// Links
$link: $aquamarine;
$link-invert: $aquamarine-invert;
$link-focus-border: $aquamarine;

$menu-item-active-background-color: $garnet;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Remove horizontal scrollbars that are visible on every page
// by default. Apparently, this could be done by setting
// Sass variables [1] which did not work here for some reason.
// Maybe there is some interference with Buefy or the Sass
// compiler or something else. Also the `body-overflow-x` might
// be outdated as they can't be found in the Bulma package. Or
// the Bulma version used is too old.
//
// The scrollbars appear on the <body> element when needed, so
// setting overflow to 'visible' should by OK as it essentially
// reverts back any values Bulma might have set. Visible is
// the default value. [2]
//
// [1] https://github.com/jgthms/bulma/issues/1293
// [2] https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
html {
	overflow: visible !important;
}

::selection {
  background-color: $aquamarine;
  color: white;
}

.loadingBar {
  position: fixed;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  z-index: 50;
}

.loadingBar:before {
  display: block;
  position: absolute;
  content: ' ';
  left: 200px;
  width: 200px;
  height: 4px;
  background-color: $aquamarine;
  animation: loading 2s linear infinite;
}

@keyframes loading {
  from {
    left: -500px;
    width: 30%
  }

  50% {
    width: 30%;
  }

  70% {
    width: 70%;
  }

  80% {
    left: 50%;
    opacity: 0;
  }

  95% {
    left: 120%;
    opacity: 0;
  }

  to {
    left: 100%;
    opacity: 0;
  }
}

.toast-item {
  width: 100%
}

.toast-container {
  display: flex;
  flex-wrap: wrap;
}

.toast-container>div {
  flex: 0 50%;
}

.print-footer {
  display: none !important;
  margin-top: 10px;
}

.fob-only-for-print-view {
  display: none !important;
}

@media print {

  html, body {
    background: white !important;
    border: none !important;
  }

  #fob-main-section {
    padding: 0px;
  }

  // content view
  #fob-main-section column:nth-child(2) {
    padding: 0px;
  }

  .fob-only-for-print-view {
    display: inline-flex !important;
  }

  .fob-hide-in-print {
    display: none !important;
  }

  #fob-menu {
    display: none;
  }

  #fob-header {
    display: none;
  }

  .fob-entity-list, .fob-entity-compact {
    box-shadow: none;
    font-size: 0.7rem;
  }

  .fob-publikation-compact-link a {
    color: inherit;
  }

  .fob-entity-list-bar {
    display: none !important;
    margin-bottom: 0px;
  }

  .card {
    box-shadow: none;
  }

  .fob-public-view, .fob-about-me {
    margin: 0px !important;
    padding: 0px !important;

    .columns .column {
      line-height: 1.25 !important;

      .level {
        margin: 0px !important;
        padding: 0px !important;
      }
    }

    .tab-content {
      display: block;
    }

    nav.tabs {
      display: none;
    }
  }

  .fob-entity-compact-view {
    ul {
      padding: 0em !important;

      li {
        margin: 0px !important;
      }
    }
  }

  .fob-entity-list-options {
    min-height: 50px;

    .card {
      display: none !important;
      margin-bottom: 0px;
    }

    .fob-entity-list-filter-tags {
      display: inline-flex !important;
      margin-bottom: 0rem !important;
      position: absolute;
      top: 0px;
      width: 55%;

      .tags {
        margin: 0 0.5rem 0rem 0;

        span {
          font-size: 0.5rem;
        }

        .delete {
          display: none;
        }

        .tag {
          border: solid 1px black;
          color: black !important;
        }

        .tag:nth-child(2) {
          margin-left: -1px;
        }
      }
    }

  }

  .fob-entity-list th:nth-child(2), .fob-entity-list td.button-column {
    display: none;
  }

  .fob-entity-list .level {
    display: none;
  }

  .fob-entity-list li {
    margin-bottom: 5px !important;
  }

  .print-footer {
    display: block !important;
    font-size: 10px !important;
  }

  // fix page breaks in firefox with long tables
  .columns {
    display: block !important;
  }

  .fob-entity-header {
    margin-bottom: 10px !important;
  }

  .fob-entity-details {
    font-size: 0.7rem;

    .fobpanel {
      font-size: 0.7rem !important;
      .panel-heading {
        font-size: 1em !important;
        padding: 2px !important;
      }

      .panel-block {
        .fob-entity.compact-print-view {
          div {
            display: inline-block;
          }

          .column-key {
            display: none;
          }

          .compact-print-view-label .column-value::after {
            content: ":"
          }
        }
      }
    }

    ul {
      li {
        margin-bottom: 0.5rem !important;
      }
    }

    .columns {
      margin: 0px;
      line-height: 1;

      .column:first-child {
        page-break-after: auto;
        font-weight: 600 !important;
      }

      .column {
        width: 100% !important;
        padding: 0.2rem !important;
      }
    }
  }


  .fob-public-view {
    .level {
      margin-bottom: 0rem;
    }
  }

  .fob-public-view-no-data {
    font-size: 0.7rem;
    padding: 0rem;

    .column {
      margin: 0px;
      padding: 0px;
      display: inline-block !important;
    }
  }

  .fob-public-heading {
    display: inline-block;
    margin-bottom: 0px !important;
    line-height: 0.35 !important;
    height: 50px;

    .fob-public-heading-label {
      margin: 0px;
      padding: 0px;
    }
  }
  // add table borders
  // table {
  //   border:solid #000 !important;
  //   border-width:1px 0 0 1px !important;

  //   th, td {
  //     border:solid #000 !important;
  //     border-width:0 1px 1px 0 !important;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/App.vue